var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box"},[_c('el-input',{staticClass:"filter-input",attrs:{"prefix-icon":"el-icon-search","placeholder":"搜索","clearable":""},on:{"input":_vm.onEmit},model:{value:(_vm.nameFilter),callback:function ($$v) {_vm.nameFilter=$$v},expression:"nameFilter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }